/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_MASTER_CATEGORIES = gql`
  query GetMasterCategories {
    masterCategories {
      results {
        id
        name
      }
    }
  }
`
